import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Avatar from 'src/components/avatar';
import RouterLink from 'src/modules/shared/links/routerLink';
import { buildPostQuery } from 'src/utils/router';
import { trackFootfallEvent } from 'src/utils/footfall';
import signupContext from 'src/constants/signupContext';
import CollapsibleList from 'src/modules/community/shared/components/sidebar/collapsibleList';

export default class SidebarPostList extends React.Component {
  static propTypes = {
    posts: PropTypes.array.isRequired,
    signupContext: PropTypes.object,
    limit: PropTypes.number,
    showMoreUrl: PropTypes.string,
    onPostClick: PropTypes.func,
    onShowMoreClick: PropTypes.func,
  };

  static defaultProps = {
    signupContext: {
      element: signupContext.element.AVATAR,
      section: signupContext.section.POST,
    },
    onPostClick: () => {},
    onShowMoreClick: () => {},
  };

  constructor(props) {
    super(props);
  }

  onClick = (post) => {
    const { posts, footfallTrackingEvent, onPostClick } = this.props;
    const postId  = post.postId || post.id;
    const postIds = posts.map(x => x.id);
    if (footfallTrackingEvent) {
      trackFootfallEvent(footfallTrackingEvent, { postId, postIds });
    }
    onPostClick();
  };

  renderPosts = posts => {
    return (
      <CollapsibleList
        className="sidebar__post-list"
        items={posts}
        limit={this.props.limit}
        mapper={post => {
          const { author, title, group } = post;
          const linkToPost = `/${group.groupCode}/posts/${post.id}/${post.urlEncodedTitle}`;
          return (
            <li className="sidebar__post-list__item" key={`sidebar__post-${post.id}`}>
              <span className="sidebar__post-list__link__avatar">
                <Link as={linkToPost} href={buildPostQuery(post, group)}>
                  <RouterLink
                    className="userlink-avatar-link"
                    href={linkToPost}
                    onCustomClick={() => {
                      this.onClick(post);
                    }}
                  >
                    <Avatar name={author.username || ''} size="small"
                      src={author.avatar} />
                  </RouterLink>
                </Link>
              </span>
              <Link as={linkToPost} href={buildPostQuery(post, group)}>
                <RouterLink
                  className="sidebar__post-list__link"
                  href={linkToPost}
                  onCustomClick={() => {
                    this.onClick(post);
                  }}
                >
                  {title}
                </RouterLink>
              </Link>
            </li>
          );
        }}
        showMoreUrl={this.props.showMoreUrl}
        onShowMoreClick={this.props.onShowMoreClick}
      />
    );
  };

  render() {
    const { posts } = this.props;
    if (posts.length === 0) return null;
    return this.renderPosts(posts);
  }
}
